<template lang="pug">
  v-layout.box-agente-desktop-formatter(column style="margin-top: 1em;")
    v-flex(v-if="nombre")
      v-layout(row)
        v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
          v-img
            img(:src="iconpersona" style="height:1.5em; width:1.5em")
        v-flex(style="align-self: center;")
          span(style="font-size: 14px;color: #454A6C;") {{nombre}}
    v-flex(style="margin-top: 1em;" v-if="correo")
      v-layout(row)
        v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
          v-img
            img(:src="iconCorreo" style="height:1.5em; width:1.5em")
        v-flex(style="align-self: center;")
          span(style="font-size: 14px;text-decoration-line: underline;color: #0855C4;text-transform: lowercase !important;") {{correo}}
    v-flex(style="margin-top: 2em;" v-if="celular")
      v-layout(row)
        v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
          v-img
            img(:src="iconCelular" style="height:1.5em; width:1.5em")
        v-flex(style="align-self: center;")
          span(style="font-size: 14px;color: #454A6C;") {{celular}}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: [
    'correo',
    'celular',
    'nombre',
    'openPopup',
    'taggeo'
  ],
  data () {
    return {
      iconCelular: require('./../../assets/icons/icon-whatsapp-gris.svg'),
      iconCorreo: require('./../../assets/icons/icon-email-gris.svg'),
      iconpersona: require('./../../assets/icons/icon-person-gris.svg'),
      iconAgente: require('./../../assets/icons-mis-seguros/icon-mi-agente.svg'),
      iconAgente2: require('./../../assets/icons-mis-seguros/icono-mi-agente2.svg'),
      nubeTexto: require('./../../assets/icons-mis-seguros/icono-nube.svg')
    }
  },
  mounted () {
    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Mi asesor', metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'mi agente'
      }
    })
  },
  methods: {
    ...mapActions('event', ['eventLog'])
  }
}
</script>

<style scoped>
.box-agente-desktop-formatter .box-text-icon-agente-formatter {
  position: absolute;
  z-index: 1;
  top: 3px;
  left: 8px;
  height: 3em;
  width: 6.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  text-align: center;
}

.box-mensaje-agente {
  position: absolute;
  right: -4em;
  top: 1em;
  background: red;
  height: 4em;
  z-index: 1;
  width: 7em;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/MiAgenteMobile.vue